function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.667969 7.99984C0.667969 3.94975 3.95121 0.666504 8.0013 0.666504C12.0514 0.666504 15.3346 3.94975 15.3346 7.99984C15.3346 12.0499 12.0514 15.3332 8.0013 15.3332C3.95121 15.3332 0.667969 12.0499 0.667969 7.99984ZM11.1185 5.5084C11.3899 5.7572 11.4082 6.17891 11.1594 6.45032L7.49274 10.4503C7.36647 10.5881 7.18818 10.6665 7.00131 10.6665C6.81443 10.6665 6.63614 10.5881 6.50987 10.4503L4.8432 8.63214C4.59441 8.36073 4.61274 7.93902 4.88416 7.69022C5.15557 7.44143 5.57728 7.45976 5.82607 7.73118L7.00131 9.01324L10.1765 5.54936C10.4253 5.27795 10.847 5.25961 11.1185 5.5084Z"
});

function SvgCheckCircleFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFilled);
export default __webpack_public_path__ + "static/media/check-circle-filled.8f7fa0d1.svg";
export { ForwardRef as ReactComponent };